import c from "vue";
import a from "lodash/get";
import f from "lodash/isBoolean";
import l from "lodash/isEqual";
import u from "./components/loading.vue.js";
const m = c.extend(u), g = {
  type: "skeleton",
  textClass: "pendo-loading-text",
  overlayProps: {
    class: "pendo-loading-overlay",
    transition: "pendo-loading-fade"
  },
  spinnerProps: {
    class: "pendo-loading-spinner",
    color: "#2a2c35",
    background: "#f4f4f7",
    size: 24
  },
  skeletonProps: {
    class: "pendo-loading-skeleton",
    speed: 2,
    borderRadius: 3,
    animate: !0,
    primaryColor: "#eaecf1",
    secondaryColor: "#f8f8f9"
  }
};
function h(e) {
  return {
    type: e.type || i.options.type,
    text: e.text || i.options.text,
    textClass: e.textClass || i.options.textClass,
    preventRelativeParent: e.preventRelativeParent || i.options.preventRelativeParent,
    overlayProps: {
      ...i.options.overlayProps,
      ...e.overlayProps
    },
    spinnerProps: {
      ...i.options.spinnerProps,
      ...e.spinnerProps
    },
    skeletonProps: {
      ...i.options.skeletonProps,
      ...e.skeletonProps
    }
  };
}
function d(e) {
  return f(e) ? e : e && typeof e == "object" ? e.loading : !1;
}
function P(e) {
  !e.domVisible && e.style.display !== "none" && e.style.visibility !== "hidden" ? (!["absolute", "fixed"].includes(e.originalPosition) && !e.instance.preventRelativeParent && e.classList.add("pendo-loading-parent--relative"), e.domVisible = !0, e.appendChild(e.mask), e.instance.visible = !0, e.domInserted = !0) : e.domVisible && e.instance.hiding === !0 && (e.instance.visible = !0, e.instance.hiding = !1);
}
function r(e, { value: n }) {
  if (n)
    e.originalPosition = e.style.position, P(e);
  else {
    e.instance.visible = !1, e.instance.hiding = !0;
    const t = e.instance.$watch("hiding", () => {
      e.instance.hiding || (e.domVisible = !1, e.classList.remove("pendo-loading-parent--relative"), t());
    });
  }
}
function y(e, { arg: n, value: t }) {
  const o = {
    ...h({
      type: n || "skeleton",
      ...t
    })
  }, s = new m({ el: document.createElement("div"), data: o });
  return e.instance = s, e.mask = s.$el, e;
}
function p({ el: e }) {
  requestAnimationFrame(() => {
    let n = e.clientHeight, t = e.clientWidth;
    e.instance.type === "skeleton" && (n = a(
      e.instance,
      "skeletonProps.height",
      e.parentElement ? e.parentElement.clientHeight : e.clientHeight
    ), t = a(
      e.instance,
      "skeletonProps.width",
      e.parentElement ? e.parentElement.clientWidth : e.clientWidth
    )), e.instance.setContainerSize({ height: n, width: t });
  });
}
function v(e, { arg: n, value: t }) {
  const o = y(e, { arg: n, value: t });
  d(t) && (r(o, { value: !0 }), p({ el: e }));
}
function k(e, { oldValue: n, value: t }) {
  if (l(n, t))
    return;
  const o = d(t);
  return o && p({ el: e }), r(e, { value: o });
}
function b(e) {
  e.domInserted && (e.mask && e.mask.parentNode && e.mask.parentNode.removeChild(e.mask), r(e, { value: !1 })), e.instance && e.instance.$destroy();
}
const i = {
  options: g,
  mounted: v,
  updated: k,
  unmounted: b
};
export {
  g as LOADING_DEFAULTS,
  i as PendoLoading,
  y as createLoader,
  i as default,
  d as getLoadingValue,
  h as getOptions,
  P as insertDom,
  v as mounted,
  r as toggleLoading,
  b as unmounted,
  k as updated
};
//# sourceMappingURL=pendo-loading.js.map
